export default __webpack_public_path__ + "static/media/marca03.57f94733.png";